module.exports = __webpack_public_path__ + "img/fushimi-HP-nyuka-003.b0de2f90.jpg";